namespace SPA {
	export namespace types {
		export enum BuilderFactoryType {
			management = 1,
			customer = 2,
			infopane = 3,
			inferioritem = 4
		}
	}
}
